import {
  ITableSortLabel,
  ITableCell,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  ITypography,
  Typography
} from '@sanlam-glacier/app-common/components';
import { TableHeaderConfig } from 'types/table/TableHeaderConfig.type';

export type TableHeaderProps<T> = {
  headers: TableHeaderConfig<T>[];
  orderBy?: string;
  handleSort?: (property: TableHeaderConfig<T>['key'] | string) => void;
  direction?: ITableSortLabel['direction'];
  align?: ITableCell['align'];
  tableHeaderClassName?: string;
  disabled?: boolean;
  actionHeaderKey?: string;
  hoverable?: boolean;
  sticky?: boolean;
  textAlign?: ITypography['align'];
};

export const TableHeader = <T,>({
  direction,
  orderBy,
  headers,
  handleSort,
  align,
  tableHeaderClassName,
  disabled,
  actionHeaderKey,
  hoverable,
  sticky
}: TableHeaderProps<T>) => {
  const hasSortHandler = !!handleSort;

  const getCellAlignment = (header: TableHeaderConfig<T>) => {
    if (header.align === 'left') return TableCell.ALIGN.LEFT;
    if (header.align === 'right') return TableCell.ALIGN.RIGHT;
  };

  const getTypographyAlignment = (header: TableHeaderConfig<T>) => {
    if (header.align === 'left') return Typography.ALIGN.LEFT;
    if (header.align === 'right') return Typography.ALIGN.RIGHT;
  };

  const getSortLabelAlignmentClass = (header: TableHeaderConfig<T>) => {
    if (header.align === 'right') return 'table-cell-sort-right';
    return '';
  };

  return (
    <TableHead sticky={sticky}>
      <TableRow className={tableHeaderClassName} disabled={disabled} hoverable={hoverable}>
        {headers.map((header, index) => (
          <TableCell
            key={(header.key as string) ?? index}
            align={getCellAlignment(header) ?? align}
            variant={TableCell.VARIANT.HEAD}
            className={`inner-header-cell ${header.className} ${
              header.key && header.key === actionHeaderKey ? 'table-action-column' : ''
            }`}
          >
            {header.renderCellContent ? (
              header.renderCellContent()
            ) : hasSortHandler && header.key ? (
              <TableSortLabel
                className={`${tableHeaderClassName} ${getSortLabelAlignmentClass(header)}`}
                active={orderBy === header.key && hasSortHandler}
                direction={direction}
                onClick={() => handleSort(header.key)}
              >
                <HeaderLabel title={header.label}>{header.label}</HeaderLabel>
              </TableSortLabel>
            ) : (
              <HeaderLabel align={getTypographyAlignment(header)} title={header.label}>
                {header.label}
              </HeaderLabel>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
type HeaderProps = {
  children: string;
  align?: ITypography['align'];
  title?: string;
};
const HeaderLabel = ({ children, align, title }: HeaderProps) => (
  <Typography
    weight={Typography.WEIGHT.MEDIUM}
    variant={Typography.VARIANT.B3}
    color={Typography.COLOR.SECONDARY}
    className={`table-header-label`}
    align={align}
    title={title}
  >
    {children}
  </Typography>
);
